import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PoweredByStrip from "@/components/PoweredByStrip";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import Programs from "@/pages/Programs";
import Packages from "@/pages/Packages";
import HowItWorks from "@/pages/HowItWorks";
import PartnerWithUs from "@/pages/PartnerWithUs";
import About from "@/pages/About";
import FAQs from "@/pages/FAQs";
import Disclaimer from "@/pages/Disclaimer";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">{children}</main>
      <PoweredByStrip />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/*" element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/destinations" element={<Destinations />} />
                  <Route path="/destinations/:slug" element={<DestinationDetail />} />
                  <Route path="/programs" element={<Programs />} />
                  <Route path="/packages" element={<Packages />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/partner" element={<PartnerWithUs />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/faqs" element={<FAQs />} />
                  <Route path="/disclaimer" element={<Disclaimer />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/apply" element={<Apply />} />
                </Routes>
              </PublicLayout>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
